import { ChevronRight } from "lucide-react";
import { MetricValue } from "@/components/marketing/MetricValue";
import { num } from "@/lib/marketing";

/** Horizontal on desktop, vertical on mobile. Conversion is shown between
    stages and never invented when the previous stage is empty. */
export const FunnelStages = ({ stages, testid = "campaign-funnel" }) => (
  <div data-testid={testid}
    className="flex flex-col lg:flex-row lg:items-stretch gap-3">
    {stages.map((s, i) => (
      <div key={s.key} className="flex flex-col lg:flex-row lg:items-center gap-3 flex-1">
        <div data-testid={`funnel-stage-${s.key}`}
          className="flex-1 rounded-2xl border border-slate-200 bg-white p-4 shadow-sm">
          <p className="text-[11px] uppercase tracking-wider font-bold text-slate-500">
            {s.label}
          </p>
          <p className="text-2xl font-black text-slate-900 mt-1">
            <MetricValue metric={s.metric ?? s.value} format={num}
              testid={`funnel-value-${s.key}`} />
          </p>
          {i > 0 && (
            <p className="text-[11px] text-slate-500 mt-1">
              {s.conversionLabel || "From previous stage"}:{" "}
              <MetricValue metric={s.conversion} format={(v) => `${v}%`}
                testid={`funnel-conversion-${s.key}`} />
            </p>
          )}
          {s.note && <p className="text-[11px] text-amber-700 mt-1">{s.note}</p>}
        </div>
        {i < stages.length - 1 && (
          <ChevronRight className="hidden lg:block h-5 w-5 text-slate-300 shrink-0" />
        )}
      </div>
    ))}
  </div>
);
